import React, { useEffect, useRef } from 'react';

//Material UI
import { Box, Button, Grid, Portal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

//Zustands
import { useMainStore } from 'useStores/useMainStore';

//Packages
import moment from 'moment-jalaali';
import { useMutation } from 'react-query';
import { isMobile } from 'react-device-detect';

//Components
import DatePicker from 'components/TextFields/DatePicker';
import Accordion from '../../../../../components/Accordion/Accordion';
import { useOnlineDriversStore } from 'useStores/useOnlineDriversStore';
import axios from 'api/axios';
import { useSearchParams } from 'hooks/useSearchParams';
import SelectState from 'components/FormInputs/SelectState';
import SelectCities from 'components/FormInputs/SelectCities2';

const useStyles = makeStyles((theme) => ({
  searchButton: {
    width: 150,
  },
  accordion: {
    zIndex: 999,
  },
  selectMenu: {
    zIndex: 10000,
    width: '100%',
  },
  selectMenuCity: {
    zIndex: 10000,
    width: '100%',
  },
}));

const Filters = () => {
  const classes = useStyles();
  const firstRender = useRef(true);
  const [params, setParams] = useSearchParams();

  const changeStartDate = useOnlineDriversStore(
    (state) => state.changeStartDate
  );
  const changeEndDate = useOnlineDriversStore((state) => state.changeEndDate);
  const changeLoading = useOnlineDriversStore((state) => state.changeLoading);
  const startDate = useOnlineDriversStore((state) => state.startDate);
  const endDate = useOnlineDriversStore((state) => state.endDate);
  const page = useOnlineDriversStore((state) => state.page);
  const selectedState = useOnlineDriversStore((state) => state.selectedState);
  const setSelectedState = useOnlineDriversStore(
    (state) => state.setSelectedState
  );
  const limit = useMainStore((state) => state.limit);

  const setDrivers = useOnlineDriversStore((state) => state.setDrivers);

  const getOnlineDrivers = async () => {
    setParams([
      { name: 'page', value: page },
      { name: 'limit', value: limit },
      { name: 'from', value: moment(startDate)?.format('YYYY-MM-DD') },
      { name: 'to', value: moment(endDate)?.format('YYYY-MM-DD') },
      { name: 'role', value: 'customer' },
    ]);
    const res = await axios.get(
      `/api/v1/admin/reports/listAppDrivers?page=${params.get(
        'page'
      )}&limit=${limit}`
    );
    return res;
  };

  const { mutate, isLoading } = useMutation(getOnlineDrivers, {
    onSuccess: ({ data: { drivers } }) => {
      setDrivers(drivers);
      changeLoading(false);
    },
    onMutate: () => {
      changeLoading(true);
    },
  });

  // const handleCheckboxChange = (e) => {
  //   const { name, checked } = e.target;
  //   changeCheckBox(name, checked);
  // };

  const handleClickSearchButton = () => {
    mutate({
      page: params.get('page'),
      limit,
      // from: moment(params.get('from'))?.format('YYYY-MM-DD'),
      // to: moment(params.get('endDate'))?.format('YYYY-MM-DD'),
      // roles: ['driver'],
    });
  };

  useEffect(() => {
    if (firstRender.current) {
      handleClickSearchButton();

      firstRender.current = false;
    } else {
      handleClickSearchButton();
    }
  }, [page, limit]);

  return (
    <Accordion
      className={classes.accordion}
      title="فیلترها"
      open={isMobile ? false : true}
    >
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12} md={4} className="d-flex " style={{ gap: 8 }}>
          <DatePicker
            label="ازتاریخ"
            value={startDate}
            onChange={(e) => changeStartDate(e)}
          />
          <DatePicker
            label="تا‌تاریخ"
            value={endDate}
            onChange={(e) => changeEndDate(e)}
          />
        </Grid>
        <Grid item xs={12} md={2} className="d-flex" style={{ gap: 8 }}>
          <SelectState
            menuPortalTarget={document.body}
            className={classes.selectMenu}
            onSelect={(e) => setSelectedState(e)}
          />
        </Grid>
        <Grid item xs={12} md={2} className="d-flex" style={{ gap: 8 }}>
          <SelectCities
            state={selectedState.value}
            menuPortalTarget={document.body}
            className={classes.selectMenuCity}
            onSelect={(e) => console.log(e)}
          />
        </Grid>
        <Grid item justifyContent="flex-end" className="d-flex" xs={4} md={4}>
          <Box className={classes.spacer} />
          <Button
            color="secondary"
            variant="contained"
            className={classes.searchButton}
            onClick={handleClickSearchButton}
            disabled={isLoading}
          >
            {isLoading ? 'در حال جستجو ...' : 'جستجو'}
          </Button>
        </Grid>
      </Grid>
    </Accordion>
  );
};

export default React.memo(Filters);
